import styled from 'styled-components'
import { DARK_VIOLET, GRAYSCALE_300, VIOLET_600 } from '@styles/colors'
import { INTER } from '@styles/fonts'
import { safeAreaInset } from '@lib/telegram'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`

export const TopUpCryptoSelectAssetContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  overflow-y: auto;
`

export const Divider = styled.div`
  display: flex;
  width: 100%;
  height: 1px;
  background-color: ${GRAYSCALE_300};
  margin: 14px 0;
  margin-bottom: 18px;
`

export const NetworksContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  padding-right: 8px;
  padding-bottom: 100px;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${GRAYSCALE_300};
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${VIOLET_600};
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${DARK_VIOLET};
  }
`

export const NetworkItem = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }
`

export const NetworkName = styled.span`
  font-family: ${INTER.regular};
  color: ${DARK_VIOLET};
`

export const RadioButtonLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`

interface CustomRadioProps {
  $outlineColor?: string;
  $outlineWidth?: number;
  $centerColor?: string;
  $size?: number;
}

export const CustomRadio = styled.span<CustomRadioProps>`
  display: inline-block;
  width: ${props => props.$size || 20}px;
  height: ${props => props.$size || 20}px;
  border-radius: 50%;
  border: ${props => props.$outlineWidth || 2}px solid ${props => props.$outlineColor || GRAYSCALE_300};
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${props => (props.$size || 20) / 2}px;
    height: ${props => (props.$size || 20) / 2}px;
    border-radius: 50%;
    background-color: ${props => props.$centerColor || VIOLET_600};
    opacity: 0;
    transition: opacity 0.2s ease;
  }
`

export const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  
  &:checked + ${CustomRadio}::after {
    opacity: 1;
  }
  
  &:focus + ${CustomRadio} {
    box-shadow: 0 0 0 2px rgba(94, 90, 219, 0.3);
  }
`

export const NetworkItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const NetworkDivider = styled.div`
  height: 1px;
  background-color: ${GRAYSCALE_300};
  margin: 16px 0;
`

export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  background-color: white;
  z-index: 1000;
`
